<template>
  <div>
    <div v-if="this.loading">
      <px-circular-loading/>
    </div>
    <div v-if="!this.loading && produtos.length > 0">
      <template v-for="(produto, index) in produtos">
        <v-list-item :key="produto.id">
          <v-list-item-content>
            <v-list-item-title>
              <v-row dense>
                <v-col cols="12" sm="6" class="text-truncate">
                  <px-span-tooltip v-if="checkCodigo(produto.produto)"
                    top
                    :text="labelCodigo(produto.produto)"
                    tooltip="Código interno"/>
                  {{ produto.produto.descricao }}
                  <px-historico-preco-produto small
                                              :produto="produto.produto"
                                              :unidade-medida="produto.unidadeMedida"/>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        {{ produto.quantidade
                          | number(getCurrencyFormat(produto.produto.casasDecimais)) }}
                        {{ produto.unidadeMedida.descricao }}
                      </span>
                    </template>
                    <span>Quantidade</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        {{ produto.precoUnitario | currency('R$', produto.produto.casasDecimais) }}
                      </span>
                    </template>
                    <span>Preço unitário</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        {{ produto.total | currency('R$', produto.produto.casasDecimais) }}
                      </span>
                    </template>
                    <span>Preço total</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="showDivider(index)" :key="`v-div${produto.id}`"/>
      </template>
    </div>
    <div v-else>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <v-row>
              <v-col cols="12">
                <div class="text-center">
                  Este rascunho não tem nenhum produto informado
                </div>
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </div>
  </div>
</template>

<script>
import { CasaDecimalUtils } from 'px-components';
import CompraService from '../compra-service';

export default {
  props: {
    compra: {},
  },
  computed: {
    showDivider() {
      return index => index !== (this.produtos.length - 1);
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    checkCodigo() {
      return item => item.codigo;
    },
    labelCodigo() {
      return item => `${item.codigo} -`;
    },
  },
  data() {
    return {
      produtos: {},
      loading: false,
    };
  },
  created() {
    this.loading = true;
    CompraService.getCompraProdutos(this.compra.id)
      .then((data) => {
        this.produtos = data.data;
        this.loading = false;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>
